import { useEffect, useState } from "react";
import { Loader2, Activity } from "lucide-react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

const ICON = {
  vendor_registered: "🟢", product_added: "📦", product_updated: "✏️", formation_created: "🎓",
  subscription_requested: "💳", subscription_renewed: "🔄", payment_method_requested: "💰",
  payment_method_activated: "✅", account_blocked: "🔒", account_activated: "🔓", order_received: "🛒",
};

export default function AdminVendorActivities() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/vendor-activities").then(({ data }) => setItems(data)).catch(() => setItems([]));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="space-y-5" data-testid="admin-vendor-activities">
      <div><h1 className="font-display text-2xl font-extrabold text-ink">Activité des revendeurs</h1>
        <p className="mt-1 text-sm text-slate-500">Flux en temps réel (actualisé toutes les 30s).</p></div>
      {items === null ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div> :
        !items.length ? <div className="rounded-2xl border border-dashed border-line bg-white p-10 text-center text-sm text-slate-500"><Activity className="mx-auto mb-2 h-8 w-8 text-slate-300" />Aucune activité pour le moment.</div> : (
          <div className="rounded-2xl border border-line bg-white p-2">
            {items.map((a) => (
              <div key={a.id} data-testid={`activity-${a.id}`} className="flex items-center gap-3 rounded-xl px-3 py-2.5 hover:bg-surface">
                <span className="text-lg">{ICON[a.type] || "•"}</span>
                <span className="flex-1 text-sm text-ink">{a.message}</span>
                <span className="text-xs text-slate-400">{formatDateTime(a.created_at)}</span>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
